module.exports = function() {
  return new Worker(__webpack_public_path__ + "26d9fab2eb0b601127d8.worker.js");
};